import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  AISummaryIcon,
  Announcement,
  GPTIcon,
  IconButton,
  ThumbsDownIcon,
  ThumbsUpIcon,
} from '@utilities';
import { createSummaryGPTFeedback } from '@api/instant_survey/surveyGPT';
import styles from './_index.module.scss';

const TextSummary = ({ data, header = 'Summary' }) => {
  const getInitialSelectedFeedback = () => {
    if (data?.userLeftFeedback) {
      return data?.userLeftNegativeFeedback ? false : true;
    }
    return null;
  };

  const [isSavingFeedback, setIsSavingFeedback] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(getInitialSelectedFeedback());
  const userId = useSelector((state) => state.user?.data?.id);
  const wasHelpful = selectedFeedback === true;
  const wasNotHelpful = selectedFeedback === false;

  const handleFeedback = async (feedback) => {
    if (isSavingFeedback || feedback === selectedFeedback) return;

    setIsSavingFeedback(true);

    try {
      const feedbackData = {
        feedback: feedback ? 'POSITIVE' : 'NEGATIVE',
        job: data?.id,
        user_id: userId,
      };
      await createSummaryGPTFeedback({ data: feedbackData, jobId: data?.id });

      setSelectedFeedback(feedback);
      setIsSavingFeedback(false);
    } catch (error) {
      console.error('Failed to save feedback:', error);
    } finally {
      setIsSavingFeedback(false);
    }
  };

  const footer = (
    <div className={styles['text-summary-footer']}>
      <GPTIcon />
      <p>
        Generated by Numerator AI<sup>BETA</sup>
      </p>
      <IconButton
        className={wasHelpful ? styles['active'] : ''}
        onClick={() => handleFeedback(true)}
        tooltip="This was helpful"
      >
        <ThumbsUpIcon />
      </IconButton>
      <IconButton.Danger
        className={wasNotHelpful ? styles['active'] : ''}
        onClick={() => handleFeedback(false)}
        tooltip="This was not helpful"
      >
        <ThumbsDownIcon />
      </IconButton.Danger>
    </div>
  );

  return (
    <Announcement
      className={styles['text-summary']}
      footer={footer}
      hasClose
      header={header}
      icon={<AISummaryIcon className={styles['text-summary-icon']} />}
      text={<ReactMarkdown>{data?.output}</ReactMarkdown>}
      variant="ai"
    />
  );
};

TextSummary.propTypes = {
  data: PropTypes.object,
  header: PropTypes.string,
};

export default TextSummary;
